module.exports = __webpack_public_path__ + "static/media/crescendo-logo.23b4472c.jpg";